// Store 타입 정의
import { create } from "zustand";

type Store = {
  shopTotalCount: number;
  setShopTotalCount: (shopTotalCount: any) => void;
};

const shopTotalCountStore = (set: any): Store => ({
  shopTotalCount: 0,
  setShopTotalCount: (shopTotalCount) => set({ shopTotalCount }),
});

const useShopTotalCountStore = create(shopTotalCountStore);

export default useShopTotalCountStore;
